(function() {
  'use strict';

  var DISCOUNT_KEY = 'cordstudioSpecialDiscount';
  var APPLIED_CLASS = 'CordEarlyAccessPrice--active';
  var refreshQueued = false;
  var currencySyncQueued = false;

  function storageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      // No-op.
    }
  }

  function readDiscountFromVerifiedKeys() {
    try {
      for (var index = 0; index < window.sessionStorage.length; index += 1) {
        var key = window.sessionStorage.key(index);
        if (!key || key.indexOf('cordstudioOtpPopupVerified:') !== 0) {
          continue;
        }

        var parsed = JSON.parse(window.sessionStorage.getItem(key) || 'null');
        if (parsed && parsed.eligible && parsed.discount) {
          return parsed.discount;
        }
      }
    } catch (error) {
      return null;
    }

    return null;
  }

  function getDiscount() {
    var raw = storageGet(DISCOUNT_KEY);
    var discount = null;

    if (raw) {
      try {
        discount = JSON.parse(raw);
      } catch (error) {
        discount = null;
      }
    }

    if (!discount) {
      discount = readDiscountFromVerifiedKeys();
      if (discount) {
        storageSet(DISCOUNT_KEY, JSON.stringify(discount));
      }
    }

    if (!discount || String(discount.type || '').toLowerCase() !== 'percentage') {
      return null;
    }

    var value = parseFloat(discount.value);
    if (!isFinite(value) || value <= 0) {
      return null;
    }

    if (value <= 1) {
      value *= 100;
    }

    if (value >= 100) {
      return null;
    }

    if (discount.expires_at) {
      var expiresAt = Date.parse(discount.expires_at);
      if (expiresAt && Date.now() > expiresAt) {
        return null;
      }
    }

    discount.value = value;
    return discount;
  }

  function formatMoney(cents) {
    var themeSettings = window.theme || {};
    var format = themeSettings.currencyCodeEnabled
      ? themeSettings.moneyWithCurrencyFormat
      : themeSettings.moneyFormat;

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && format) {
      return window.Shopify.formatMoney(cents, format);
    }

    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatString.match(placeholderRegex);

    if (!match) {
      return '$' + (Math.round(cents) / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;

      var rounded = (Math.round(number) / 100).toFixed(precision);
      var parts = rounded.split('.');
      var dollars = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';

      return dollars + centsPart;
    }

    var value = '';
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function parseMoneyText(text) {
    var match = String(text || '').replace(/\s+/g, ' ').match(/([0-9][0-9,]*(?:\.[0-9]{1,2})?)/);
    if (!match) {
      return 0;
    }

    return Math.round(parseFloat(match[1].replace(/,/g, '')) * 100);
  }

  function priceCentsFor(element) {
    var fromData = parseInt(element.getAttribute('data-cordstudio-ea-price-cents') || '0', 10);
    if (fromData > 0) {
      return fromData;
    }

    var parsed = parseMoneyText(element.textContent);
    return parsed > 0 ? parsed : 0;
  }

  function renderPriceList(element, discount) {
    if (!element || element.getAttribute('data-cordstudio-ea-busy') === '1') {
      return false;
    }

    if (element.getAttribute('data-cordstudio-ea-gift-card') === 'true') {
      return false;
    }

    var cents = priceCentsFor(element);
    var percent = discount.value;
    var saleCents = Math.round(cents * (100 - percent) / 100);

    if (!cents || !saleCents || saleCents >= cents) {
      return false;
    }

    var key = [cents, saleCents, percent].join(':');
    if (element.getAttribute('data-cordstudio-ea-applied') === key && element.querySelector('.CordEarlyAccessPrice__Sale')) {
      return false;
    }

    var context = element.getAttribute('data-cordstudio-ea-context') || '';
    var saleClass = context === 'product'
      ? 'ProductMeta__Price Price Price--highlight Text--subdued u-h4'
      : context.indexOf('cart') === 0
        ? 'CartItem__Price Price Price--highlight'
        : 'ProductItem__Price Price Price--highlight Text--subdued';
    var compareClass = context === 'product'
      ? 'ProductMeta__Price Price Price--compareAt Text--subdued u-h4'
      : context.indexOf('cart') === 0
        ? 'CartItem__Price Price Price--compareAt'
        : 'ProductItem__Price Price Price--compareAt Text--subdued';
    var prefix = element.getAttribute('data-cordstudio-ea-price-varies') === 'true' ? 'From ' : '';
    var badge = Math.round(percent) + '% off';

    element.setAttribute('data-cordstudio-ea-busy', '1');
    element.setAttribute('data-cordstudio-ea-applied', key);
    element.classList.add(APPLIED_CLASS);
    element.innerHTML = [
      '<span class="' + saleClass + ' CordEarlyAccessPrice__Sale">' + prefix + formatMoney(saleCents) + '</span>',
      '<span class="' + compareClass + ' CordEarlyAccessPrice__Compare">' + formatMoney(cents) + '</span>',
      '<span class="CordEarlyAccessPrice__Badge">' + badge + '</span>'
    ].join(' ');
    element.removeAttribute('data-cordstudio-ea-busy');
    return true;
  }

  function renderCartTotal(element, discount) {
    if (!element || element.getAttribute('data-cordstudio-ea-busy') === '1') {
      return false;
    }

    var cents = parseInt(element.getAttribute('data-cordstudio-ea-price-cents') || '0', 10);
    var discountableCents = parseInt(element.getAttribute('data-cordstudio-ea-discountable-cents') || String(cents), 10);
    discountableCents = Math.min(cents, Math.max(0, discountableCents));

    if (!discountableCents) {
      return false;
    }

    var saleCents = cents - Math.round(discountableCents * discount.value / 100);
    if (!cents || !saleCents || saleCents >= cents) {
      return false;
    }

    var key = [cents, saleCents, discount.value].join(':');
    if (element.getAttribute('data-cordstudio-ea-applied') === key && element.querySelector('.CordEarlyAccessPrice__Sale')) {
      return false;
    }

    var labelPrefix = '';
    if (element.matches('p')) {
      labelPrefix = element.textContent.split(':')[0] + ': ';
    }

    element.setAttribute('data-cordstudio-ea-busy', '1');
    element.setAttribute('data-cordstudio-ea-applied', key);
    element.classList.add(APPLIED_CLASS);
    element.innerHTML = labelPrefix + '<span class="CordEarlyAccessPrice__Sale">' + formatMoney(saleCents) + '</span> <span class="CordEarlyAccessPrice__Compare">' + formatMoney(cents) + '</span>';
    element.removeAttribute('data-cordstudio-ea-busy');
    return true;
  }

  function queueCurrencyConverterSync() {
    if (currencySyncQueued) {
      return;
    }

    currencySyncQueued = true;
    window.setTimeout(function() {
      var api = window.codeblackbelt && window.codeblackbelt['currency-converter-plusApi'];

      currencySyncQueued = false;

      if (!api || typeof api.convertPrices !== 'function') {
        return;
      }

      try {
        api.convertPrices();
      } catch (error) {
        // Currency Converter Plus can throw after partially converting dynamic prices.
      }
    }, 50);
  }

  function refresh() {
    var discount = getDiscount();
    if (!discount) {
      return;
    }

    var changed = false;
    document.documentElement.classList.add('CordEarlyAccessPriceActive');

    document.querySelectorAll('[data-cordstudio-ea-price-list]').forEach(function(element) {
      changed = renderPriceList(element, discount) || changed;
    });

    document.querySelectorAll('[data-cordstudio-ea-cart-total]').forEach(function(element) {
      changed = renderCartTotal(element, discount) || changed;
    });

    if (changed) {
      queueCurrencyConverterSync();
    }
  }

  function queueRefresh() {
    if (refreshQueued) {
      return;
    }

    refreshQueued = true;
    window.requestAnimationFrame(function() {
      refreshQueued = false;
      refresh();
    });
  }

  function installObserver() {
    if (!window.MutationObserver) {
      return;
    }

    var observer = new MutationObserver(queueRefresh);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function installStyles() {
    if (document.getElementById('CordEarlyAccessPriceStyles')) {
      return;
    }

    var style = document.createElement('style');
    style.id = 'CordEarlyAccessPriceStyles';
    style.textContent = [
      '.CordEarlyAccessPrice--active{display:flex;align-items:baseline;gap:7px;flex-wrap:wrap}',
      '.CordEarlyAccessPrice__Compare{text-decoration:line-through;opacity:.58}',
      '.CordEarlyAccessPrice__Badge{color:#6f7c62;font-size:11px;font-weight:600;letter-spacing:0;text-transform:uppercase}',
      '.Cart__Total .CordEarlyAccessPrice__Compare,[data-cordstudio-ea-cart-total] .CordEarlyAccessPrice__Compare{text-decoration:line-through;opacity:.58;margin-left:6px}',
      '.Cart__Total .CordEarlyAccessPrice__Sale,[data-cordstudio-ea-cart-total] .CordEarlyAccessPrice__Sale{font-weight:600}'
    ].join('');
    document.head.appendChild(style);
  }

  window.CordstudioEarlyAccessPricing = {
    refresh: refresh
  };

  installStyles();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      refresh();
      installObserver();
    });
  } else {
    refresh();
    installObserver();
  }
})();
